export default __webpack_public_path__ + "static/BeeD2-12861cbc6ee1e182f1f5988a566ca601.png";